import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import PreLoaderGIF from '../assets/preloader.gif';
import {Container, Row} from 'reactstrap';
import Property from '@episerver/spa-core/Components/Property';

const PreLoader = ({data, context, isFromLeadPage}) => {
  let preloaderGifSrc = PreLoaderGIF;

  let content = isFromLeadPage ? (
    <div>
      <Property context={context} iContent={data} field='tittleWaitingPageLead' />
      <Property className='client-location-preloader__subtext' context={context} iContent={data} field='subTittleWaitingPageLead' />
    </div>
  ) : (
    <div>
      <Property context={context} iContent={data} field='tittleWaitingPage' />
      <Property className='client-location-preloader__subtext' context={context} iContent={data} field='subTittleWaitingPage' />
    </div>
  );

  return (
    <Container>
      <div className='client-location-preloader'>
        {/* <Property context={context} iContent={data} field='tittleWaittingPage' /> */}
        {content}
        {/* <Property className='client-location-preloader__subtext' context={context} iContent={data} field='subTittleWaitingPage' /> */}
        <Image src={preloaderGifSrc} alt='loader' />
      </div>
    </Container>
  );
};
export default PreLoader;
